import { useMemo } from "react";
import { useGetReportTemplatesByArenaQuery } from "~/graphql/supergraphHooks";
import { ReportTemplate } from "./types";

/**
 * Fetches report templates for a specific arena.
 *
 * @param arenaId - The arena ID, or null for system templates
 * @param options - Optional options to skip the query
 * @returns templates - Empty array during loading or on error; populated on success.
 *          Use queryResult.loading, queryResult.error to distinguish states.
 * @returns queryResult - Full Apollo query result for loading/error state handling. Contains the query result and the templates.
 */
export const useFetchTemplatesByArena = (
  arenaId: number | null,
  options?: { skip?: boolean },
) => {
  const queryResult = useGetReportTemplatesByArenaQuery({
    variables: { arenaId },
    fetchPolicy: "cache-and-network",
    skip: options?.skip,
  });

  const templates = useMemo<ReportTemplate[]>(() => {
    if (queryResult.loading || !queryResult.data?.reportTemplatesByArena) {
      return [];
    }

    return queryResult.data.reportTemplatesByArena;
  }, [queryResult.loading, queryResult.data]);

  return { templates, queryResult };
};
